import React, { FC } from "react";
import { AiOutlineCalendar } from "react-icons/ai";

import InputSelect from "global/InputSelect/InputSelect";
import DatePickers from "global/DatePicker/DatePicker";
import InputText from "global/InputText/InputText";
import SectionCard from "./SectionCard";

interface SurveyBasicInfoFormProps {
  values: any;
  touched: any;
  errors: any;
  setFieldValue: (field: string, value: any) => void;
  questionTypeOptions: any[];
}

const SurveyBasicInfoForm: FC<SurveyBasicInfoFormProps> = ({
  values,
  touched,
  errors,
  setFieldValue,
  questionTypeOptions,
}) => {
  return (
    <SectionCard
      title="اطلاعات پایه نظرسنجی"
      subTitle="عنوان، نوع، بازه زمانی و مشخصات اصلی فرم را وارد کنید"
      icon={<AiOutlineCalendar size={22} />}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <InputText
          wrapperClassName="md:col-span-2 xl:col-span-4"
          label="عنوان فرم"
          important
          name="title"
          handleChange={(e) => setFieldValue("title", e.target.value)}
          values={values.title}
          error={touched.title && (errors.title as string)}
        />

        <InputSelect
          wrapperClassName="z-[30]"
          label="نوع نظرسنجی"
          important
          name="surveyType"
          handleChange={setFieldValue}
          values={values.surveyType}
          error={touched.surveyType && (errors.surveyType as string)}
          options={questionTypeOptions || []}
          positionFixed
        />

        <DatePickers
          title="از تاریخ"
          name="validFrom"
          WrapperClassName="w-full"
          handleChange={setFieldValue}
          values={values.validFrom}
          important
          error={touched.validFrom && (errors.validFrom as any)?.day}
          
        />

        <DatePickers
          title="تا تاریخ"
          name="validTo"
          WrapperClassName="w-full"
          handleChange={setFieldValue}
          values={values.validTo}
          important
          minDate={values.validFrom}
          error={touched.validTo && (errors.validTo as any)?.day}
        />
      </div>
    </SectionCard>
  );
};

export default SurveyBasicInfoForm;
